import { styled } from 'src/styles/stitches.config'

export const EventWrapper = styled('div', {
    borderBottom: 'solid 1px $primary',
    paddingBottom: '$xs',
})
